/**
 * ValueType for "auto"
 */
var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};

export { auto };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.mjs
// module id = 5YsX
// module chunks = 0